$ ->
  $(document)
    .on 'click', '.selector', (e) ->
      $selector = $(e.currentTarget)
      $tpl = $selector.next('.tpl-selector-menu')
      cls = 'dropdown-list scrollable'
      cls += ' no-arrow' unless $tpl.hasClass('with-arrow')
      return unless $tpl.length

      simple.popover
        pointTo: $selector
        content: $tpl.html()
        position: 'bottom-center'
        cls: cls
        offset:
          x: 0
          y: -10

    .on 'click', '.selector-menu:not(.custom) .selector-option', (e) ->
      e.preventDefault()
      $target = $(@)
      type = $target.closest('.selector-menu').data 'type'
      value = $target.data 'value'
      url = simple.url()

      switch type
        when 'project'
          key = 'project_guid'
        when 'member'
          key = 'member_guid'
        when 'subgroup'
          key = 'subgroup_guid'
        else
          key = type if type?

      if key?
        if value? && value != ''
          url.search[key] = value
        else
          url.removeParam(key)

      tower.stack.load url.toString('relative'),
        replace: true
        nocache: true
